import axios from "axios.js";
import { showSnackbar } from "./UiAction";

export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const GET_STUDENTS = "GET_STUDENTS";
export const GET_ACTIVITY_DETAILS = "GET_ACTIVITY_DETAILS";
export const UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS";
export const GET_SCHOOL_PROFILE_DETAILS = "GET_SCHOOL_PROFILE_DETAILS";
export const GET_SCHOOL_SYNC_STUDENTS = "GET_SCHOOL_SYNC_STUDENTS";

export const getProfileDetails = () => (dispatch) => {// get profile api call
  axios.get(`/profile`).then((res) => {
    dispatch({
      type: GET_PROFILE_DETAILS,
      payload: res.data,
    });
  });
};

export const getActivityDetails = (size, data) => (dispatch) => {
  axios.post(`/report/activity?page=1&size=${size}`, data).then((res) => {
    dispatch({
      type: GET_ACTIVITY_DETAILS,
      payload: res.data,
    });
  });
};

export const updateProfileDetails = (data) => (dispatch) => { // update profile api call
  axios
    .post("/school/profile", data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, 'top', "success"));
      dispatch({
        type: UPDATE_PROFILE_DETAILS,
        payload: response.data,
      });
      dispatch(getProfileDetails())
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getSChoolProfileDetails = () => (dispatch) => {// get profile api call
  axios.get(`/school/profile`).then((res) => {
    dispatch({
      type: GET_SCHOOL_PROFILE_DETAILS,
      payload: res.data,
    });
  });
};

export const getSchoolSyncStudents = () => (dispatch) => {// get student sync api call
  axios.get(`/school/sync/students`).then((res) => {
    dispatch({
      type: GET_SCHOOL_SYNC_STUDENTS,
      payload: res.data,
    });
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  }).catch((error) => {
    dispatch(showSnackbar(error.message, 'top', "error"));
  });;
};